import { EditorState, StateEffect, StateField } from '@codemirror/state';
import { type Tooltip, showTooltip } from '@codemirror/view';

export const readOnlyTooltipStateEffect = StateEffect.define<boolean | { show: boolean; text?: string }>();

export const readOnlyTooltipStateField = StateField.define<readonly Tooltip[]>({
  create: () => [],
  update(_tooltips, transaction) {
    if (!transaction.state.readOnly) {
      return [];
    }

    for (const effect of transaction.effects) {
      if (effect.is(readOnlyTooltipStateEffect)) {
        const { value } = effect;

        const showTooltip = typeof value === 'boolean' ? value : value.show;
        const tooltipText = typeof value !== 'boolean' ? value.text : undefined;

        if (showTooltip) {
          return getTooltip(transaction.state, tooltipText);
        }
      }
    }

    return [];
  },
  provide: (field) => {
    return showTooltip.computeN([field], (state) => state.field(field));
  },
});

function getTooltip(state: EditorState, text?: string) {
  if (!state.readOnly) {
    return [];
  }

  return state.selection.ranges.map((range) => {
    return {
      pos: range.head,
      above: true,
      strictSide: true,
      arrow: true,
      create: () => {
        const divElement = document.createElement('div');
        divElement.className = 'cm-readonly-tooltip';
        divElement.textContent = text ?? 'Cannot edit file while AI response is being generated';

        return { dom: divElement };
      },
    };
  });
}
